import script from "./RecentOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentOrders.vue?vue&type=script&setup=true&lang=js"

import "./RecentOrders.vue?vue&type=style&index=0&id=52f12d6a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f12d6a"]])

export default __exports__